import { render, staticRenderFns } from "./SideDetailCard.vue?vue&type=template&id=6b628066&"
import script from "./SideDetailCard.vue?vue&type=script&lang=js&"
export * from "./SideDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports